import React, { Component } from 'react'
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { CERRAR } from './../../../../constants/icons/dashboard/filterIcons';
import SvgIcon from '@material-ui/core/SvgIcon';
import './style.css'

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../../../Actions/Dashboard';

class Tag extends Component {


  handleCloseTag = () => {
    this.props.actions.selectFilter({ id: this.props.dato.id, value: this.props.dato.value}, this.props.dato.name)
  }

  render() {
    return (
        <Button >
          <div style={{ marginLeft: 1, marginRight: 1 }} >
            <Typography style={{ color: 'white', fontSize: 12, fontWeight: 'bold' }}>
              {`${this.props.dato.value} `}
            </Typography>
          </div>

          <SvgIcon style={{ color: 'white', fontSize: 15, marginLeft: 15, }} onClick={this.handleCloseTag}>
            {CERRAR}
          </SvgIcon>

        </Button> 
    )

  }
}


function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(null, mapDispathToProps)(Tag);
